export default __webpack_public_path__ + "static/media/caroucel.1c7dd1fd.png";